<template>
  <div class="quote-details pad-single">
    <p class="title">Instant quote</p>
    <p class="subtitle">Fill in your details and we'll send you your quote.</p>
    <small class="is-block mb-3">
      <span class="icon is-small text-brand-primary-600">
        <Icon :icon="faBolt" />
      </span>
      <span class="text-brand-primary-600"> Average delivery time 2 minutes </span>
    </small>

    <static-form
      button-colour="is-success"
      submit-text="Get your instant quote"
      @submit-form="submitForm"
    />
  </div>
</template>
<script setup>
// import { ref, computed } from 'vue'
// import { mapActions, mapGetters } from 'vuex'
// import { updateDataLayer } from '../../helpers/util'
// import { fbLeadEvent } from '../../helpers/util'
// import DataForm from '../form/Form.vue'
import StaticForm from '../form/StaticQuoteContactForm.vue'
// import { getUTMFromLocalStorage } from '../../helpers/util'
import Icon from '../components/Icon.vue'
import { faBolt } from '@repo/icons/light/faBolt'

const emit = defineEmits(['submitForm'])

async function submitForm(fields) {
  // Convert to key value pairs before sending
  // const data = {
  //   contactDetails: {},
  // }
  const contactDetails = {}
  Object.keys(fields).forEach((key) => {
    contactDetails[key] = fields[key]
  })
  // fields.forEach(field => {
  //   data.contactDetails[field.name] = field.value
  // })

  // Api expects printers
  // data.printers = this.products

  // Get UTM data from local storage
  // const utmData = getUTMFromLocalStorage()

  // if (utmData) {
  //   data.utm = utmData
  // }

  // this.$api.Form.getQuoteData(data).then(response => {
  //   // reset basket
  //   // this.clearBasket()
  //   // this.switchModal('Confirmation')
  //   this.storeQuoteData(response)
  // })
  emit('submitForm', contactDetails)
  // this.$api.Form.submitUniForm('quote', data).then(() => {
  //   // Send event to GA before showing confirmation
  //   updateDataLayer('event', 'quote_request_submitted')
  //   // Send lead event to fb
  //   fbLeadEvent()
  //   // reset basket
  //   this.clearBasket()
  //   this.switchModal('Confirmation')
  // })
}

// import { useBasketStore } from '@/store/modules/basket.ts'
// import { useModal } from '@/composables/useModal.js'

// const basketStore = useBasketStore()
// const modal = useModal()

// export default {
//   name: 'DetailsForm',
//   components: {
//     // DataForm,
//     StaticForm,
//   },
//   data() {
//     return {
//       faBolt,
//       // formData: [
//       //   {
//       //     // label: 'Name',
//       //     name: 'name',
//       //     icon: 'fa-user',
//       //     // validations: { presence: { allowEmpty: false } },
//       //     validations: ['presence'],
//       //     value: '',
//       //     placeholder: 'Name',
//       //     type: 'text',
//       //     autocomplete: 'name',
//       //     required: true,
//       //   },
//       //   {
//       //     // label: 'Email',
//       //     name: 'email',
//       //     icon: 'fa-envelope',
//       //     // validations: { presence: { allowEmpty: false }, email: true },
//       //     validations: ['presence', 'email'],
//       //     value: '',
//       //     placeholder: 'Email',
//       //     type: 'email',
//       //     autocomplete: 'email',
//       //     required: true,
//       //   },
//       //   // {
//       //   //   label: 'Company',
//       //   //   name: 'company',
//       //   //   icon: 'building',
//       //   //   validations: { presence: { allowEmpty: false } },
//       //   //   value: '',
//       //   //   placeholder: 'Company name',
//       //   //   type: 'text'
//       //   // }
//       //   {
//       //     // label: 'Phone number',
//       //     name: 'phone',
//       //     icon: 'fa-phone',
//       //     // validations: {
//       //     //   presence: { allowEmpty: false },
//       //     //   format: {
//       //     //     pattern: 'phoneNumber',
//       //     //     message: 'is not a valid phone number',
//       //     //   },
//       //     // },
//       //     validations: ['presence', 'phonenumber'],
//       //     value: '',
//       //     placeholder: 'Phone number',
//       //     type: 'text',
//       //     required: true,
//       //   },
//       //   {
//       //     // label: 'Postcode',
//       //     name: 'postCode',
//       //     icon: 'fa-map-marker',
//       //     // validations: {
//       //     //   presence: { allowEmpty: false },
//       //     //   format: { pattern: 'postCode', message: 'is not a valid postcode' },
//       //     // },
//       //     validations: ['presence', 'postCode'],
//       //     value: '',
//       //     placeholder: 'Postcode',
//       //     type: 'text',
//       //     autocomplete: 'postal-code',
//       //     required: true,
//       //   },
//       // ],
//     }
//   },
// computed: {
//   ...mapGetters({
//     basket: 'getBasket',
//     isInstant: 'isInstant',
//     instant: 'getInstantItem',
//   }),
//   products() {
//     // Only send modelId of items in basket
//     return this.isInstant ? [this.instant] : Object.keys(this.basket)
//   },
// },
// methods: {
//   ...mapActions(['closeModal', 'switchModal', 'clearBasket', 'storeQuoteData']),
//     submitForm(fields) {
//       // Convert to key value pairs before sending
//       // const data = {
//       //   contactDetails: {},
//       // }
//       const contactDetails = {}
//       Object.keys(fields).forEach((key) => {
//         contactDetails[key] = fields[key]
//       })
//       // fields.forEach(field => {
//       //   data.contactDetails[field.name] = field.value
//       // })

//       // Api expects printers
//       // data.printers = this.products

//       // Get UTM data from local storage
//       // const utmData = getUTMFromLocalStorage()

//       // if (utmData) {
//       //   data.utm = utmData
//       // }

//       // this.$api.Form.getQuoteData(data).then(response => {
//       //   // reset basket
//       //   // this.clearBasket()
//       //   // this.switchModal('Confirmation')
//       //   this.storeQuoteData(response)
//       // })
//       this.$emit('submitForm', contactDetails)
//       // this.$api.Form.submitUniForm('quote', data).then(() => {
//       //   // Send event to GA before showing confirmation
//       //   updateDataLayer('event', 'quote_request_submitted')
//       //   // Send lead event to fb
//       //   fbLeadEvent()
//       //   // reset basket
//       //   this.clearBasket()
//       //   this.switchModal('Confirmation')
//       // })
//     },
//   },
// }
</script>
